/**
 * Model reprezentujący pakiet danych rejestracyjnych przesyłany
 * do bramki Przelewy24 w celu utworzenia konta sprzedawcy (Merchanta).
 * Umożliwia zautomatyzowany onboarding kliniki do systemu płatności online.
 */
export class P24RegistrationData {


  /** Globalnie unikalny identyfikator rekordu rejestracji w lokalnej bazie. */
  public uuid: string;

  /** Vetcode placówki, która jest podmiotem rejestracji. */
  public vetcodeId: number;

  /** Pełna nazwa zarejestrowanej działalności gospodarczej / spółki. */
  public bdName: string;

  /** Główny firmowy adres e-mail. */
  public bdEmail: string;

  /** Adres e-mail dedykowany do przesyłania faktur prowizyjnych przez Przelewy24. */
  public invoiceEmail: string;

  /** Główny numer telefonu do firmy. */
  public bdPhone: string;

  /** Kod pocztowy siedziby firmy. */
  public bdPostalCode: string;

  /** Miasto siedziby firmy. */
  public bdCity: string;

  /** Ulica wraz z numerem budynku i lokalu (siedziba). */
  public bdStreetWithNumber: string;

  public correspondencePostalCode: string;
  public correspondenceCity: string;
  public correspondenceStreetWithNumber: string;


  /** Nazwa banku, w którym klinika posiada rachunek firmowy. */
  public bankName: string;

  /** Numer rachunku bankowego, na który Przelewy24 będą przelewać środki. */
  public bankAccount: string;

  /** Opis świadczonych usług. */
  public servicesDescription: string;

  /** Typ formy prawnej działalności gospodarczej.
   * Zmapowany na słownik numeryczny wymagany przez API Przelewy24
   */
  public businessType: number;

  /** Numer w Krajowym Rejestrze Sądowym. */
  public krs: string;

  /** Numer Identyfikacji Podatkowej (NIP). */
  public taxId: string;

  /** Numer PESEL (wymagany przez instytucje finansowe w przypadku np. jednoosobowych działalności). */
  public personalId: string;

  /** Numer w rejestrze REGON. */
  public regon: string;


  /** Imię i nazwisko osoby do kontaktu w sprawach informatycznych / integracyjnych. */
  public technicalPersonName: string;
  public technicalPersonEmail: string;
  public technicalPersonPhone: string;

  /** Imię i nazwisko głównej osoby decyzyjnej / reprezentanta firmy. */
  public contactPersonName: string;
  public contactPersonEmail: string;
  public contactPersonPhone: string;



  /** Adres URL wygenerowany w odpowiedzi przez API Przelewy24.
   * Pod ten link aplikacja kieruje właściciela kliniki,
   * aby dokończył proces weryfikacji tożsamości.
   */
  public p24RegistrationUrl: string;

}
